/** 分组管理页。 */

import { useCallback, useEffect, useState } from "react";

import { listGroups, type Group } from "@/api/groups";
import { GroupEditor } from "@/components/GroupEditor";

export default function GroupsPage() {
  const [groups, setGroups] = useState<Group[]>([]);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState<Group | null | "new">(null);

  const reload = useCallback(() => {
    setLoading(true);
    listGroups()
      .then(setGroups)
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return (
    <div className="mx-auto max-w-2xl p-4">
      <header className="mb-4 flex items-center justify-between">
        <h1 className="text-xl font-semibold text-slate-900">分组管理</h1>
        <button
          onClick={() => setEditing("new")}
          className="rounded-full bg-sky-600 px-4 py-2 text-sm text-white hover:bg-sky-700"
        >
          新建分组
        </button>
      </header>

      {loading ? (
        <div className="py-12 text-center text-sm text-slate-400">加载中…</div>
      ) : groups.length === 0 ? (
        <div className="rounded-xl border border-dashed border-slate-200 p-8 text-center text-sm text-slate-500">
          <div className="mb-2 text-3xl">👥</div>
          还没有分组。创建一个后就可以在共享时一次性发给多个人。
        </div>
      ) : (
        <ul className="space-y-2">
          {groups.map((g) => (
            <li
              key={g.id}
              onClick={() => setEditing(g)}
              className="cursor-pointer rounded-xl border border-slate-200 bg-white p-4 shadow-sm transition hover:shadow-md"
            >
              <div className="flex items-center justify-between">
                <div>
                  <div className="font-medium text-slate-900">{g.name}</div>
                  <div className="mt-0.5 text-xs text-slate-500">
                    {g.members.length} 位成员
                  </div>
                </div>
                <div className="flex flex-wrap gap-1">
                  {g.members.slice(0, 4).map((m) => (
                    <span
                      key={m.open_id}
                      className="rounded-full bg-slate-100 px-2 py-0.5 text-xs text-slate-600"
                    >
                      {m.name ?? m.open_id}
                    </span>
                  ))}
                  {g.members.length > 4 ? (
                    <span className="rounded-full bg-slate-100 px-2 py-0.5 text-xs text-slate-500">
                      +{g.members.length - 4}
                    </span>
                  ) : null}
                </div>
              </div>
            </li>
          ))}
        </ul>
      )}

      {editing !== null ? (
        <GroupEditor
          group={editing === "new" ? null : editing}
          onClose={() => setEditing(null)}
          onSaved={() => {
            setEditing(null);
            reload();
          }}
        />
      ) : null}
    </div>
  );
}
